import useSWR from 'swr';

export default function useApi(url, options = {}) {
  const { data, error, isLoading, mutate } = useSWR(url, {
    revalidateOnMount: true,
    revalidateIfStale: true,
    ...options
  });

  return {
    data,
    error,
    isLoading,
    refresh: mutate
  };
}
